import { z } from 'zod';
import { createErrorHandler } from './helpers/error-handler';
export const enumValidator = ({ values, invalidValueError, requiredError, }) => {
    return z.enum(values, {
        error: createErrorHandler(requiredError, invalidValueError),
    });
};
export const enumValidatorTuples = ({ values, invalidValueError, requiredError, }) => {
    return z.enum(values, {
        error: createErrorHandler(requiredError, invalidValueError),
    });
};
